import { render } from "./SubjectInput.vue?vue&type=template&id=07ea716b"
import script from "./SubjectInput.vue?vue&type=script&lang=js"
export * from "./SubjectInput.vue?vue&type=script&lang=js"

import "./SubjectInput.vue?vue&type=style&index=0&id=07ea716b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__